import React, { useState } from 'react';
import { IoClose } from 'react-icons/io5';
import classes from './PromoBanner.module.scss';
import { INSURANCE_BASE_URL } from '../../../../constants';

const PromoBanner = () => {
    const [showBanner, setShowBanner] = useState(true);

    const handleClose = () => {
        setShowBanner(false);
    };

    return (
        <div className={`${classes.promoBanner} ${!showBanner ? classes['promoBanner--hidden'] : ''}`}>
            <div className={classes.promoBanner__contentWrapper}>
                <div className={classes.promoBanner__content}>
                    <span className={classes.promoBanner__message}>
                        Planning your child's future? Don't skip protection.
                    </span>
                    <a
                        className={classes.promoBanner__consultButton}
                        href={`${INSURANCE_BASE_URL}/book-call`}
                        target="_blank"
                    >
                        Book a free 15 min consult
                    </a>
                    <span className={classes.promoBanner__message}>
                        with our <span className={classes.promoBanner__guardianOneText}>Guardian One</span> experts
                    </span>
                </div>
                <button
                    className={classes.promoBanner__closeButton}
                    onClick={handleClose}
                    aria-label='Close banner'
                >
                    <IoClose size={20} />
                </button>
            </div>
        </div>
    );
};

export default PromoBanner;
